import {
  prepareRequest
} from './request'

import SettingsManager from '../managers/settings'

/*
  Service provides methods for authorization http or sockets
  Also included ClientManagment Api methods
  Handling auth token storage
 */

export class AuthServiceError extends Error {
  name = 'AuthServiceError'
}

export const getClientProfile = options => {
  const request = prepareRequest({
    method: 'GET',
    url: 'client/clients:profile'
  })

  return request(options)
}

export const updateUserLanguage = options => {
  const request = prepareRequest({
    method: 'POST',
    url: 'client/clients:updateLanguage'
  })

  return request(options)
}

export const updateMarketingInfo = options => {
  const request = prepareRequest({
    method: 'POST',
    url: 'client/clients:updateMarketingState'
  })
  return request(options)
}

export const updateLimitsSet = options => {
  const request = prepareRequest({
    method: 'POST',
    url: 'client/clients:setLimits'
  })
  return request(options)
}

export const closeAccount = options => {
  const request = prepareRequest({
    method: 'POST',
    url: 'client/clients:closeAccount'
  })
  return request(options)
}

// TODO: Remove login without form when form generator will be implemented on all platforms
export const login = options => {
  const request = prepareRequest({
    method: 'POST',
    url: 'auth/login',
    headers: {
      'x-request-ip': '0.0.0.0'
    }
  })

  return request(options)
}

export const loginWithForm = options => {
  const request = prepareRequest({
    url: 'client/clients:login-with-form',
    method: 'POST'
  })

  return request(options)
}

export const registation = options => {
  const request = prepareRequest({
    method: 'POST',
    url: 'client/clients:register'
  })

  return request(options)
}

export const registerWithForm = options => {
  const {
    lang = 'ENG',
    affiliateId = null
  } = SettingsManager.settings

  const request = prepareRequest({
    method: 'POST',
    url: 'client/clients:register-with-form',
    headers: {
      lang,
      ...(affiliateId ? { 'X-Affiliate-ID': affiliateId } : {})
    }
  })

  return request(options)
}

export const logout = () => {
  const request = prepareRequest({
    url: 'auth/logout',
    method: 'GET'
  })

  return request()
}

// Request for email with link to the 'secret page' with change password functionality
export const restorePassword = ({ email }) => {
  const request = prepareRequest({
    method: 'POST',
    url: 'client/clients:initPasswordReset'
  })

  return request({ email })
}
export const initPasswordResetWithForm = (options) => {
  const request = prepareRequest({
    url: 'client/clients:initPasswordReset-with-form',
    method: 'POST'
  })

  return request(options)
}

// Applying new password with token from email
export const passwordReset = (options) => {
  const request = prepareRequest({
    url: 'client/clients:passwordReset',
    method: 'POST'
  })

  return request(options)
}

export const profileUpdate = options => {
  const request = prepareRequest({
    method: 'POST',
    url: 'client/clients:update'
  })

  return request(options)
}

export const profileUpdateWithForm = (options) => {
  const request = prepareRequest({
    method: 'POST',
    url: 'client/clients:update-with-form'
  })

  return request(options)
}

export const passwordUpdate = options => {
  const request = prepareRequest({
    method: 'POST',
    url: 'client/clients:passwordUpdate'
  })

  return request(options)
}

export const changePasswordWithForm = options => {
  const request = prepareRequest({
    method: 'POST',
    url: 'client/clients:changePassword-with-form'
  })

  return request(options)
}

export const passwordResetWithForm = options => {
  const request = prepareRequest({
    method: 'POST',
    url: 'client/clients:passwordReset-with-form'
  })

  return request(options)
}

export const getClientPreferences = () => {
  const request = prepareRequest({
    method: 'GET',
    url: 'client/clients/preferences'
  })

  return request()
}

export const setClientPreferences = options => {
  const request = prepareRequest({
    method: 'POST',
    url: 'client/clients/preferences'
  })

  return request(options)
}

export const getClientTransactionHistory = async (options) => {
  const request = prepareRequest({
    url: 'client/client/transactions:find:all',
    method: 'POST'
  })

  return request(options)
}
